import React, { useEffect, useState, useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "./sidebardata";
import Chatbot from '../Bot/Chatbot';
import { ChevronLeft, User, Grid, Layers, Bookmark, RefreshCw, Calendar, Clock, Activity, Sun, DollarSign, Camera, MapPin, Layout, Box, Briefcase, Bell, FileText, Users, Award, TrendingUp, FileMinus, FilePlus, List, Settings, Clipboard, BarChart2, Home } from 'react-feather';
import { FaUsers, FaBriefcase, FaCalendarAlt, FaPlaneArrival, FaPlaneDeparture, FaBed, FaDoorOpen } from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { t } = useTranslation();

  const [sidebarData, setSidebarData] = useState(SidebarData);
  const [isSideMenu, setIsSideMenu] = useState("employee-dashboard");
  const profileTabRef = useRef(null);
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const toggleChatbot = (e) => {
    setIsChatbotOpen((prev) => !prev);
  };

  useEffect(() => {
    if (profileTabRef.current) {
      profileTabRef.current.click();
    }
  }, []);

  useEffect(() => {
    const menuMapping = {
      '/hospitality': 'employee',
      '/departments': 'employee',
      '/designations': 'employee',
      '/profile': 'profile',
      '/leave-types': 'employee',
      '/holidays': 'employee',
      '/shift-list': 'employee',
      '/overtime': 'employee',
      '/announcements': 'employee',
      '/leaves-employee': 'leaves',
      '/adminleaves': 'leaves',
      '/leave-applications': 'leaves',
      '/leaves-balance': 'leaves',
      '/leave-settings': 'leaves',
      '/attendance-weekly': 'attendance',
      '/attendance-daily': 'attendance',
      '/adminattendance': 'attendance',
      '/attendance-employee': 'attendance',
      '/payroll-overview': 'payroll-overview',
      '/salary': 'payroll-overview',
      '/payroll-items': 'payroll-overview',
      '/run-payroll': 'payroll-overview',
      '/payroll-settings': 'payroll-overview',
      '/payroll-history': 'payroll-overview',
      '/payroll-reports': 'payroll-overview',
      '/devices': 'devices',
      '/deviceslog': 'devices',
      '/device-users': 'devices',
      '/manage-locations': 'company-settings',
      '/reports': 'reports',
      '/property-configuration': 'property-configuration',
    };

    const matchedMenu = Object.keys(menuMapping)
      .sort((a, b) => b.length - a.length)
      .find(route => pathname.startsWith(route)) || "";

    if (matchedMenu) {
      toggleSidebar(menuMapping[matchedMenu]);
    } else {
      toggleSidebar('dashboard');
    }
  }, [pathname]);

  useEffect(() => {
    if (!isSideMenu) {
      toggleSidebar('employee-dashboard');
    }
  }, []);

  const expandSubMenus = (menu) => {
    const updatedAdminSidebar = sidebarData.map((section) => {
      const updatedSection = { ...section };
      updatedSection.menu = section.menu.map((menuItem) =>
        menu.menuValue !== menuItem.menuValue
          ? { ...menuItem, showSubRoute: false }
          : { ...menuItem, showSubRoute: true }
      );
      return updatedSection;
    });
    setSidebarData(updatedAdminSidebar);
  };

  const toggleSidebar = (value) => {
    setIsSideMenu(value);
  };

  const isActive = (routes) => {
    const currentPath = window.location.pathname.replace(/\/$/, "");
    const routeArray = Array.isArray(routes) ? routes : [routes];
    return routeArray.some(path => currentPath === path.replace(/\/$/, ""));
  };

  return (
    <>
      <div className="sidebar">
        <div className="sidebar-inner slimscroll-" style={{ overflow: 'auto' }}>
          <div id="sidebar-menu" className="sidebar-menu">
            <nav className="greedys sidebar-horizantal" id="horizantal-sidebar">
              {/* Horizontal Sidebar content */}
            </nav>

            <Scrollbars
              autoHide={false}
              autoHideTimeout={1000}
              autoHideDuration={200}
              autoHeight
              autoHeightMin={0}
              autoHeightMax="100vh"
              thumbMinSize={30}
              universal={false}
              hideTracksWhenNotNeeded={true}
            >
              <ul className="sidebar-vertical" id="veritical-sidebar">
                {sidebarData.map((mainTittle, index) => (
                  <React.Fragment key={index + 1}>
                    <li className="menu-title">
                      <span>{t(mainTittle.tittle)}</span>
                    </li>
                    {mainTittle.menu.map((menu, menuIndex) => (
                      <React.Fragment key={menuIndex + 1}>
                        {!menu.hasSubRoute ? (
                          <li>
                            <Link
                              to={menu.route}
                              className={isActive([menu.route]) ? "active" : ""}
                            >
                              <i className={menu?.icon} />
                              <span>{t(menu.menuValue)}</span>
                            </Link>
                          </li>
                        ) : (
                          <li className="submenu">
                            <Link
                              to="#"
                              onClick={() => expandSubMenus(menu)}
                              className={menu.showSubRoute ? "subdrop" : ""}
                            >
                              <i className={menu?.icon} />
                              <span>{t(menu.menuValue)}</span>
                              <span className="menu-arrow" />
                            </Link>
                            <ul style={{ display: menu.showSubRoute ? "block" : "none" }}>
                              {menu.subMenus.map((subMenus, subMenu) => (
                                <React.Fragment key={subMenu + 1}>
                                  {subMenus?.showMenuRoute ? (
                                    <li>
                                      <Link
                                        to={subMenus.route}
                                        className={isActive([subMenus.route]) ? "active" : ""}
                                      >
                                        {t(subMenus.menuValue)}
                                        <span className="menu-arrow" />
                                      </Link>
                                      <ul style={{ display: subMenus.showSubRoute ? "block" : "none" }}>
                                        {subMenus?.subMenusValues?.map((value, index) => (
                                          <li key={index}>
                                            <Link
                                              to={value.route}
                                              className={isActive([value.route]) ? "active" : ""}
                                            >
                                              <span>{t(value.menuValue)}</span>
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </li>
                                  ) : (
                                    <li>
                                      <Link
                                        to={subMenus.route}
                                        className={isActive([subMenus.route]) ? "active" : ""}
                                      >
                                        {t(subMenus.menuValue)}
                                      </Link>
                                      <ul>
                                        {subMenus?.subMenusValues?.map((value, index) => (
                                          <li key={index}>
                                            <Link
                                              to={value.route}
                                              className={isActive([value.route]) ? "active" : ""}
                                            >
                                              <span>{t(value.menuValue)}</span>
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </li>
                                  )}
                                </React.Fragment>
                              ))}
                            </ul>
                          </li>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </ul>
            </Scrollbars>
          </div>
        </div>

        <div className="two-col-bar" id="two-col-bar">
          <div className="sidebar sidebar-twocol">
            <div className="sidebar-left slimscroll">
              <div
                className="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <Link
                  className={`nav-link ${isActive(["/hospitality/"]) ? "active" : ""}`}
                  title={t("Dashboard")}
                  onClick={() => toggleSidebar("dashboard")}
                  to="/hospitality/"
                >
                  <span className="material-icons-outlined">home</span>
                  <small>{t("Home")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive([
                    "/hospitality/property-configuration",
                    "/departments",
                    "/designations",
                    "/profile",
                    "/leave-types",
                    "/holiday",
                    "/shift-list",
                    "/overtime",
                  ]) ? "active" : ""}`}
                  title={t("My Property")}
                  onClick={() => toggleSidebar("/hospitality/property-configuration")}
                  to="/hospitality/property-configuration"
                >
                  <span className="material-icons-outlined">business</span>
                  <small>{t("Property")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive([
                    "/hospitality/reservation-list",
                    "/hospitality/guest-reservation",
                  ]) ? "active" : ""}`}
                  title={t("Bookings")}
                  onClick={() => toggleSidebar("/hospitality/reservation-list")}
                  to="/hospitality/reservation-list"
                >
                  <span className="material-icons-outlined">book_online</span>
                  <small>{t("Bookings")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive([
                    "/hospitality/inhouse-guest",
                    "/hospitality/guest",
                  ]) ? "active" : ""}`}
                  title={t("In House Guest")}
                  onClick={() => toggleSidebar("/hospitality/inhouse-guest")}
                  to="/hospitality/inhouse-guest"
                >
                  <span className="material-icons-outlined">person</span>
                  <small>{t("In House")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive([
                    "/hospitality/day-invoices",
                    "/deviceslogs",
                    "/users",
                  ]) ? "active" : ""}`}
                  title={t("Invoices")}
                  onClick={() => toggleSidebar("/hospitality/day-invoices")}
                  to="/hospitality/day-invoices"
                >
                  <span className="material-icons-outlined">description</span>
                  <small>{t("Invoices")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive(["/hospitality/day-end"]) ? "active" : ""}`}
                  title={t("Day End")}
                  onClick={() => toggleSidebar("/hospitality/day-end")}
                  to="/hospitality/day-end"
                >
                  <span className="material-icons-outlined">nights_stay</span>
                  <small>{t("Day End")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive(["/hospitality/day-book"]) ? "active" : ""}`}
                  title={t("Day Book")}
                  onClick={() => toggleSidebar("/hospitality/day-book")}
                  to="/hospitality/day-book"
                >
                  <span className="material-icons-outlined">book</span>
                  <small>{t("Day Book")}</small>
                </Link>
                <Link
                  className={`nav-link ${isActive([
                    "/hospitality/reports",
                    "/hospitality/occupancy-report",
                    "/hospitality/reservation-report",
                    "/hospitality/room-status-report",
                    "/hospitality/daily-room-sold",
                    "/hospitality/shift-end-summary",
                    "/hospitality/ota-booking-volume",
                    "/hospitality/daily-revenue-analysis",
                    "/hospitality/payment-mode-report/",
                    "/hospitality/sales-performance/",
                    "/hospitality/front-office-billings/",
                    "/hospitality/ota-booking-revenue/",
                    "/hospitality/roomno-wise-sales",
                    "hospitality/daily-flash-report"
                  ]) ? "active" : ""}`}
                  title={t("Reports")}
                  onClick={() => toggleSidebar("/hospitality/reports")}
                  to="/hospitality/reports"
                >
                  <span className="material-icons-outlined">insert_chart</span>
                  <small>{t("Reports")}</small>
                </Link>
                <button
                  className={`nav-link ${isChatbotOpen ? "active" : ""}`}
                  title={t("Support")}
                  onClick={toggleChatbot}
                  type="button"
                >
                  <span className="material-icons-outlined">help_outline</span>
                  <small>{t("Support")}</small>
                </button>
                <Link
                  className={`nav-link ${isActive(["/logout"]) ? "active" : ""}`}
                  title={t("Logout")}
                  onClick={() => toggleSidebar("/logout")}
                  to="/logout"
                >
                  <span className="material-icons-outlined">exit_to_app</span>
                  <small>{t("Logout")}</small>
                </Link>
              </div>
            </div>
            <div className="sidebar-right">
              <div className="tab-content-horizontal" id="v-pills-tabContent">
                {isSideMenu === "dashboard" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/employee-dashboard']) ? "active" : ""}
                            to="/employee-dashboard"
                          >
                            <Home size={16} style={{ marginRight: '4px' }} /> {t("My Dashboard")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "employee" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul className="nav-list">
                        <li>
                          <Link
                            className={isActive(['/hospitality']) ? "active" : ""}
                            to="/hospitality"
                          >
                            <FaUsers size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Dashboard")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/reservation-list']) ? "active" : ""}
                            to="/hospitality/reservation-list"
                          >
                            <FaBriefcase size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Reservations")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/calandar']) ? "active" : ""}
                            to="/hospitality/calandar"
                          >
                            <FaCalendarAlt size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Calendar")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/guest-list-card']) ? "active" : ""}
                            to="/hospitality/guest-list-card"
                          >
                            <FaPlaneArrival size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Today's Arrivals")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/list-depature-guest-card']) ? "active" : ""}
                            to="/hospitality/list-depature-guest-card"
                          >
                            <FaPlaneDeparture size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Today's Departures")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/list-checkedout-guest-card']) ? "active" : ""}
                            to="/hospitality/list-checkedout-guest-card"
                          >
                            <FaDoorOpen size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Checked-out Guest")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/room-overview']) ? "active" : ""}
                            to="/hospitality/room-overview"
                          >
                            <FaBed size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("Rooms Overview")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/hospitality/inhouse-guest']) ? "active" : ""}
                            to="/hospitality/inhouse-guest"
                          >
                            <FaUsers size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                            {t("In-House Guests")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "leaves" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/leaves-employee']) ? "active" : ""}
                            to="/leaves-employee"
                          >
                            <FileMinus size={16} className="icon-with-margin" /> {t("My Leaves")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/adminleaves']) ? "active" : ""}
                            to="/adminleaves"
                          >
                            <FilePlus size={16} className="icon-with-margin" /> {t("Leave Admin")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/leave-applications']) ? "active" : ""}
                            to="/leave-applications"
                          >
                            <List size={16} className="icon-with-margin" /> {t("Leave Requests")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/leaves-balance']) ? "active" : ""}
                            to="/leaves-balance"
                          >
                            <Activity size={16} className="icon-with-margin" /> {t("Leave Balances")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/leave-settings']) ? "active" : ""}
                            to="/leave-settings"
                          >
                            <Settings size={16} className="icon-with-margin" /> {t("Settings")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "attendance" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/attendance-weekly']) ? "active" : ""}
                            to="/attendance-weekly"
                          >
                            <Clipboard size={16} className="icon-with-margin" /> {t("My Attendance")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/attendance-daily']) ? "active" : ""}
                            to="/attendance-daily"
                          >
                            <Calendar size={16} className="icon-with-margin" /> {t("Daily Attendance")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/adminattendance']) ? "active" : ""}
                            to="/adminattendance"
                          >
                            <BarChart2 size={16} className="icon-with-margin" /> {t("Monthly Summary")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "devices" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/devices']) ? "active" : ""}
                            to="/devices"
                          >
                            <Camera size={14} style={{ marginRight: '4px' }} /> {t("Manage AI Devices")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/deviceslog']) ? "active" : ""}
                            to="/deviceslog"
                          >
                            <FileText size={14} style={{ marginRight: '4px' }} /> {t("Device Logs")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/device-users']) ? "active" : ""}
                            to="/device-users"
                          >
                            <RefreshCw size={14} style={{ marginRight: '4px' }} /> {t("Synch Users")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "company-settings" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/company-settings']) ? "active" : ""}
                            to="/company-settings"
                          >
                            <Home size={14} style={{ marginRight: '4px' }} /> {t("My Dashboard")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/manage-locations']) ? "active" : ""}
                            to="/manage-locations"
                          >
                            <MapPin size={14} style={{ marginRight: '4px' }} /> {t("Manage Locations")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/company-settings']) ? "active" : ""}
                            to="/company-settings"
                          >
                            <Settings size={14} style={{ marginRight: '4px' }} /> {t("Organization Settings")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "payroll-overview" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li>
                          <Link
                            className={isActive(['/payroll-overview']) ? "active" : ""}
                            to="/payroll-overview"
                          >
                            <Clipboard size={16} className="icon-with-margin" /> {t("Payroll Overview")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/salary']) ? "active" : ""}
                            to="/salary"
                          >
                            ₹ {t("Employee Salary")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/payroll-items']) ? "active" : ""}
                            to="/payroll-items"
                          >
                            <FileMinus size={16} className="icon-with-margin" /> {t("Salary Heads")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/run-payroll']) ? "active" : ""}
                            to="/run-payroll"
                          >
                            <FileText size={16} className="icon-with-margin" /> {t("Process Payroll")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/payroll-history"
                            className={isActive(['/payroll-history']) ? "active" : ""}
                          >
                            <Users size={16} className="icon-with-margin" /> {t("Payroll History")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive(['/payroll-settings']) ? "active" : ""}
                            to="/payroll-settings"
                          >
                            <Settings size={16} className="icon-with-margin" /> {t("Settings")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/payroll-reports"
                            className={isActive(['/payroll-reports']) ? "active" : ""}
                          >
                            <BarChart2 size={16} className="icon-with-margin" /> {t("Reports")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "reports" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li><Link to="/employee-reports">{t("Employee Reports")}</Link></li>
                        <li><Link to="/leave-reports">{t("Leave Reports")}</Link></li>
                        <li><Link to="/attendance-reports">{t("Attendance Reports")}</Link></li>
                        <li><Link to="/performance-reports">{t("Performance Reports")}</Link></li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "settings" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal">
                      <ul>
                        <li><Link to="/hospitality/property-configuration">{t("Account Settings")}</Link></li>
                        <li><Link to="/privacy-settings">{t("Privacy Settings")}</Link></li>
                        <li><Link to="/notification-settings">{t("Notification Settings")}</Link></li>
                        <li><Link to="/theme-settings">{t("Theme Settings")}</Link></li>
                      </ul>
                    </div>
                  </div>
                )}
                {isSideMenu === "profile" && (
                  <div className="tab-pane fade active show">
                    <div className="submenu-horizontal d-flex justify-content-between align-items-center">
                      <ul>
                        <li>
                          <Link to="/employees">
                            <ChevronLeft size={16} /> {t("Employee Directory")}
                          </Link>
                        </li>
                      </ul>
                      <ul className="nav nav-tabs-bottom">
                        <li>
                          <Link
                            to="#emp_profile"
                            data-bs-toggle="tab"
                            aria-selected="true"
                            className="active"
                            ref={profileTabRef}
                          >
                            <User size={16} /> {t("Personal Profile")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#emp_details"
                            data-bs-toggle="tab"
                          >
                            <Briefcase size={16} /> {t("Employment Details")}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#emp_assets"
                            data-bs-toggle="tab"
                          >
                            <Box size={16} /> {t("Assets")}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Chatbot isOpen={isChatbotOpen} toggleChatbot={toggleChatbot} />
    </>
  );
};

export default Sidebar;